// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"09e7fdb5567fb8faf8ac","655":"9e89940a80a3be0c6e20"}[chunkId] + ".js";
};